// Centralized product identity, so a rename touches exactly one place.
export const APP_NAME = "PackItUp";
